import type { Page } from '../../types';

const addRecoveredError: Page[] = [
  {
    pageType: 'question',
    title: 'Recovered error',
    name: 'recovered-error',
    description:
      'Entries should record the number of instances and the value of the loss relating to the error. Entries must include selections from the following typology dropdowns:' +
      '<ul><li>the business area in which the error occurred</li><li>the error origin - who was responsible for the initial mistake (error)?</li><li>the type of recovery that enabled the funds to be recovered</li><li>the extent of counter fraud resource involvement in the recovery of the error (this includes when counter fraud resource detected the error)</li><li>whether or not the error related to a COVID-19 scheme or activity</li></ul><br/>',
    questions: [
      {
        questionType: 'radio',
        title:
          'Do you have any instances of recovered error (partial or full recovery) to declare?',
        name: 'recovered_error_declare',
        options: ['Yes', 'No'],
        rules: {
          required: true,
        },
      },
    ],
  },
  {
    pageType: 'list',
    title: 'Add another instance',
    name: 'recovered-error-add-instance',
    type: 'nilreturn',
    fastToggle: true,
    total: {
      columns: [
        { title: 'Number of instances', field: 'recovered_error_impact' },
        { title: 'Total Value', field: 'recovered_error' },
      ],
    },
    description:
      'Refers to the amount of error recovered within the given quarter. Entries should record the number of instances and the value of the loss relating to the error. Entries must include selections from the following typology dropdowns:' +
      '<ul><li>the business area in which the error occurred</li><li>the error origin - who was responsible for the initial mistake (error)?</li><li>the type of recovery that enabled the funds to be recovered</li><li>the extent of counter fraud resource involvement in the recovery of the error (this includes when counter fraud resource detected the error)</li><li>whether or not the error related to a COVID-19 scheme or activity</li></ul><br/>',
    disabled: [
      {
        field: 'recovered_error_declare',
        condition: 'equals', // optional
        value: 'No',
      },
    ],
    questions: [
      {
        questionType: 'select',
        title: 'Which spending area/business area did the error occur in?',
        name: 'recovered_error_area',
        detailsHeading: 'Help with spending areas',
        detailsContent:
          ' <b>Benefits:</b> money given by the government to support members of the public' +
          ' <br/><b>Charges & other non-tax income:</b> money owed to public sector organisations (for example, court fines or prescription fees)' +
          ' <br/><b>Grants:</b> money given by a public sector organisation for a specific purpose' +
          ' <br/><b>Licences and permits:</b> licences, permits or certificates that grant permissions (for example, a Blue Badge, Surveyor licence, marriage certificate)' +
          ' <br/><b>Loans & credit guarantees:</b> money loaned or guaranteed by a public sector organisation' +
          ' <br/><b>Personnel:</b> employees (including contractors and agency workers)' +
          ' <br/><b>Procurement:</b> goods or services bought by public sector organisations (including suppliers)' +
          ' <br/><b>Special payments:</b> money given in unique or specific circumstances (for example, compensation)' +
          ' <br/><b>Subsidies:</b> support or incentives given by the government' +
          ' <br/><b>Tax & duties:</b> mandatory government charge for goods, income or services',
        options: [
          'Benefits',
          'Charges & other non-tax income',
          'Grants',
          'Licences and permits',
          'Loans & credit guarantees',
          'Personnel',
          'Procurement',
          'Special payments',
          'Subsidies',
          'Tax & duties',
        ],
        hintOption: 'Please Select',
        rules: {
          required: true,
        },
      },
      {
        name: 'recovered_error_deception',
        questionType: 'radio',
        title: 'Who was responsible for the error?',
        // hint: 'Select one option',
        detailsHeading: 'Who was responsible for the error?',
        hint: 'who was responsible for the unintentional mistake (error)?',
        detailsContent:
          '<b>Customer:</b> a member of the public or someone acting on behalf of a business or charity' +
          '<br/><b>Official:</b> a government department, public body or service' +
          '<br/><b>Supplier:</b> a person or business contracted to supply a service' +
          '<br/><b>Unknown:</b> I don&apos;t know who was responsible for the mistake?',
        hintOption: 'Please Select',
        options: ['Customer', 'Official', 'Supplier', 'Unknown'],
        rules: {
          required: true,
        },
      },
      {
        questionType: 'radio',
        title: 'How was the error recovered (fully or partially)?',
        detailsHeading: 'Help with recovery',
        detailsContent:
          '<b>Indemnity:</b> a policy that provides security or protection against a loss' +
          '<br/><b>Offsetting loss:</b> offset against their personal income (for example, salary or benefits)' +
          '<br/><b>Through civil proceedings:</b> the person who benefitted is forced to pay back the loss because of civil proceedings' +
          '<br/><b>Unknown:</b> I don&apos;t know how it was recovered' +
          '<br/><b>Covid commissioner voluntary repayment scheme:</b> the person or business who benefitted has repaid as part of the scheme' +
          '<br/><b>Voluntary repayment:</b> the person who benefitted pays back the loss voluntarily',
        name: 'recovered_error_recovered',
        options: [
          'Indemnity',
          'Offsetting loss',
          'Through civil proceedings',
          'Unknown',
          'Covid commissioner voluntary repayment scheme',
          'Voluntary repayment',
        ],
        rules: { required: true },
      },
      {
        questionType: 'select',
        title: 'Counter Fraud Involvement?',
        name: 'recovered_error_involvement',
        hintOption: 'Please Select',
        options: [
          'Counter fraud delivered',
          'Counter fraud influenced',
          'No counter fraud involvement',
        ],
        rules: { required: true },
      },
      {
        questionType: 'radio',
        title: 'Is this related to Covid 19 activity?',
        name: 'recovered_error_c19',
        options: ['Yes', 'No'],
        rules: { required: true },
      },
      {
        questionType: 'instanceInput',
        title: 'How many instances occurred?',
        name: 'recovered_error_impact',
        txt: `Total number of instances?`,
        rules: {
          required: true,
        },
      },
      {
        questionType: 'costInput',
        displaySeperator: 'thousand',
        title: 'What was the value of the recovered error?',
        name: 'recovered_error',
        txt: `Total value`,
        rules: {
          required: true,
          decimal: 'decimal(2)',
        },
      },
      {
        questionType: 'textarea',
        title: 'Comments',
        hideOptionalLabel: true,
        name: 'recovered_error_comments',
        hint: `Please ensure you do not include any personal or sensitive information`,
        rules: {
          required: false,
        },
      },
    ],
  },
];
export default addRecoveredError;
